import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import JwtService from '@/core/services/jwt.service'
import EventBus from '@/event-bus'

let emitLogoutOperation = false
/**
 * Service to call HTTP request via Axios
 */
const ApiService = {
  init() {
    Vue.use(VueAxios, axios)
    Vue.axios.defaults.baseURL = process.env.VUE_APP_BASE_URL
  },

  /**
   * Set the default HTTP request headers
   */
  setHeader() {
    Vue.axios.defaults.headers.common[
      'Authorization'
    ] = `${JwtService.getToken()}`
  },

  query(resource, params) {
    params = this.controlParams(params)
    return Vue.axios.get(resource, params).catch((error) => {
      throw this.controlErrorMessage(error, 'get')
    })
  },

  /**
   * Send the GET HTTP request
   * @param resource
   * @param slug
   * @returns {*}
   */
  get(resource) {
    resource = this.controlQueries(resource)

    return Vue.axios.get(`${resource}`).catch((error) => {
      // console.log(error);
      this.controlLogout(error, resource)
      throw this.controlErrorMessage(error, 'get')
    })
  },

  /**
   * Set the POST HTTP request
   * @param resource
   * @param params
   * @returns {*}
   */
  post(resource, params) {
    params = this.controlParams(params)
    return Vue.axios.post(`${resource}`, params).catch((error) => {
      this.controlLogout(error, resource)
      throw this.controlErrorMessage(error, 'post')
    })
  },
  post(resource, params, headers) {
    params = this.controlParams(params)
    return Vue.axios
      .post(`${resource}`, params, { headers: headers })
      .catch((error) => {
        this.controlLogout(error, resource)
        throw this.controlErrorMessage(error, 'post')
      })
  },

  /**
   * Send the UPDATE HTTP request
   * @param resource
   * @param slug
   * @param params
   * @returns {IDBRequest<IDBValidKey> | Promise<void>}
   */
  update(resource, slug, params) {
    params = this.controlParams(params)
    return Vue.axios.put(`${resource}/${slug}`, params).catch((error) => {
      this.controlLogout(error, resource)
      throw this.controlErrorMessage(error, 'update')
    })
  },

  /**
   * Send the PUT HTTP request
   * @param resource
   * @param params
   * @returns {IDBRequest<IDBValidKey> | Promise<void>}
   */
  put(resource, params) {
    params = this.controlParams(params)
    return Vue.axios.put(`${resource}`, params).catch((error) => {
      this.controlLogout(error, resource)
      throw this.controlErrorMessage(error, 'put')
    })
  },

  /**
   * Send the PATCH HTTP request
   * @param resource
   * @param params
   * @returns {IDBRequest<IDBValidKey> | Promise<void>}
   */
  patch(resource, params) {
    params = this.controlParams(params)
    return Vue.axios.patch(`${resource}`, params).catch((error) => {
      this.controlLogout(error, resource)
      throw this.controlErrorMessage(error, 'patch')
    })
  },

  /**
   * Send the DELETE HTTP request
   * @param resource
   * @returns {*}
   */
  delete(resource, params) {
    if (params) {
      return Vue.axios
        .delete(resource, {
          data: {
            source: params,
          },
        })
        .catch((error) => {
          this.controlLogout(error, resource)
          throw this.controlErrorMessage(error, 'delete')
        })
    } else {
      return Vue.axios.delete(resource).catch((error) => {
        this.controlLogout(error, resource)
        throw this.controlErrorMessage(error, 'delete')
      })
    }
  },

  /*
  Unauthorized'e ek olarak 'am-i-logged-in' sorgusuna istek yapmamız gerektiği için böyle bir ayrı method olarak kullanıyoruz.
  */
  controlLogout(error, payload) {
    //oauth/token/delete -> callback sayfasında sonsuz döngüye sokabiliyor.
    if (
      payload &&
      !payload.includes('oauth/token/delete') &&
      error.response &&
      error.response.data &&
      error.response.data.error &&
      error.response.data.error.code == 'ERROR-UNAUTHORIZED'
    ) {
      if (emitLogoutOperation == false) {
        emitLogoutOperation = true

        this.get(`am-i-logged-in`)
          .then(({ data }) => {
            if (data && data.data && data.data.is_ok == true) {
              //do nothing!
            } else {
              EventBus.$emit('logout')
            }
          })
          .catch((err) => {
            EventBus.$emit('logout')
          })
      }
    } else {
      emitLogoutOperation = false
    }
  },

  /*
  Dönen data standart olmadığı için kötü bir if kontrolü var. 
  Burayı elden geçirmek gerekecek.
 */
  controlErrorMessage(error, requestMethod) {
    if (
      error.response &&
      error.response.data &&
      error.response.data.error &&
      (error.response.data.error.code == 'ERROR-UNPROCESSABLE-ENTITIY' ||
        error.response.data.error.code == 'ERROR-BAD-REQUEST' ||
        error.response.data.error.code == 'ERROR-NOT-ACCEPTABLE' ||
        error.response.data.error.code == 'ERROR-NOT-FOUND' ||
        error.response.data.error.code == 'ERROR-FORBIDDEN')
    ) {
      let errors =
        error.response.data && error.response.data.error
          ? typeof error.response.data.error.errors !== 'undefined'
            ? error.response.data.error.errors
            : typeof error.response.data.error.message !== 'undefined'
            ? error.response.data.error.message.split()
            : {}
          : {}

      if (
        requestMethod == 'get' &&
        error.response.data.error.code == 'ERROR-NOT-FOUND'
      ) {
        //Arkaplanda çalışan işlemler içinde hata mesajı çıkardığı için bunu kapattım.
      } else EventBus.$emit('errors', errors)

      return errors ? errors : 'Error'
    }
    return 'Error'
  },

  /*
  Boolean değerleri 1/0 göndermemiz gerekiyor.
  Bunun gibi alanlar olursa diye de ayırdım.
  */
  controlParams(params) {
    if (params) {
      for (const [key, value] of Object.entries(params)) {
        if (typeof value == 'boolean') {
          params[key] = value ? 1 : 0
        }
      }
    }
    return params
  },
  controlQueries(resource) {
    resource = this.controlDatacenterNode(resource)
    resource = this.controlTeam(resource)
    return resource
  },
  controlDatacenterNode(resource) {
    if (
      !resource.includes('datacenterNode=') &&
      window.location.pathname.startsWith('/my-cloud/') == false
    ) {
      let dcNode = JwtService.getSelectedDataCenterNode()
      if (dcNode && dcNode.id != '') {
        resource +=
          (!resource.includes('?') ? '?' : '&') + `datacenterNode=${dcNode.id}`
      }
    }
    return resource
  },
  controlTeam(resource) {
    if (
      !resource.includes('t=') &&
      window.location.pathname.includes('/teams/') == false &&
      resource.startsWith('/me') == false &&
      resource.includes('am-i-logged-in') == false &&
      resource.includes('module-exist') == false &&
      resource.includes('user-verification') == false
    ) {
      let userTeam = JwtService.getUserTeam()
      if (userTeam && userTeam.id != '') {
        resource += (!resource.includes('?') ? '?' : '&') + `t=${userTeam.id}`
      }
    }
    return resource
  },
}

export default ApiService
